import { Flex } from '#atoms';
import styled from 'styled-components';

export const Header = styled(Flex)`
  height: 56px;
  padding: 16px 20px;
`;
export const Wrapper = styled.div`
  padding: 20px;
  margin-bottom: 100px;
`;

export const Wrapper2 = styled.div`
  padding: 5px;
`;

export const Title = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.gray15};
`;

export const Title2 = styled.span`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.gray15};
`;

export const Strong = styled.span`
  color: ${({ theme }) => theme.palette.brand300};
  line-height: 30px;
`;

export const Badge = styled.span`
  background-color: ${({ theme }) => theme.palette.brand400};
  color: white;
  border-radius: 22px;
  height: 20px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
`;

export const Description = styled.div`
  margin-top: 24px;
  color: ${({ theme }) => theme.palette.gray100};
  white-space: pre-wrap;
`;

export const Description2 = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.palette.gray100};
  white-space: pre-wrap;
`;

export const Benefis = styled(Flex)``;

export const Divider = styled.div`
  border-bottom: 10px solid ${({ theme }) => theme.palette.gray800}; // 두꺼운 구분선
  margin: 16px 0; // 상하 여백
  width: calc(100% + 32px); // 화면 너비보다 32px 더 확장 (여백에 따라 조절)
  margin-left: -16px; // 화면의 좌측 끝까지 확장
  margin-right: -16px; // 화면의 우측 끝까지 확장
  box-sizing: border-box; // border와 padding이 요소의 총 너비에 포함되도록 설정
`;

export const Benefit = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.gray15};
`;

export const PriceWrapper = styled(Flex)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.gray600};
  background-color: ${({ theme }) => theme.palette.gray800};
  padding: 20px;
`;

export const Condition = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray25};
`;

export const RegularPrice = styled.span`
  font-size: 13px;
  text-decoration-line: line-through;
  color: ${({ theme }) => theme.palette.gray100};
`;

export const PriceText = styled.span`
  color: ${({ theme }) => theme.palette.brand300};
  font-weight: 600;
`;

export const Price = styled.span`
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
`;

export const Institutions = styled.div`
  margin-top: 10px;
  width: 100%;
  padding: 30px 50px 15px 50px;
  position: relative; /* 절대 위치를 기준으로 삼기 위해 relative로 설정 */
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.gray600};
  // display: grid; /* Grid 레이아웃으로 변경 */
  // grid-template-columns: repeat(3, 1fr); /* 3개의 열로 설정 */
  // grid-template-rows: auto auto; /* 두 줄로 설정 */
  // grid-template-areas:
  //   '. item1 item2 item3 .'
  //   '. item4 item5 .'; /* 첫 번째 줄에 3개, 두 번째 줄에 2개 배치 */
  // gap: 1px; /* 항목들 간의 간격 */
  // justify-items: center; /* 항목들을 중앙으로 정렬 */
  // align-content: start; /* 항목들을 상단에 정렬 */

  // @media (max-width: 10px) {
  //   grid-template-columns: repeat(2, 1fr); /* 화면이 작을 때 2개의 열로 변경 */
  //   grid-template-rows: repeat(
  //     auto-fill,
  //     minmax(100px, auto)
  //   ); /* 자동으로 줄 높이 조정 */
  //   grid-template-areas:
  //     'item1 item2'
  //     'item3 item4'
  //     'item5 .'; /* 모바일 레이아웃에 맞게 조정 */
  // }
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Institution = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray25};
  text-align: center; /* 텍스트 중앙 정렬 */
  box-sizing: border-box; /* padding과 border를 너비에 포함되도록 설정 */
  margin-bottom: 8px; /* 아래쪽 여백 설정 */
  white-space: nowrap; /* 텍스트 줄 바꿈 방지 */
  overflow: hidden; /* 영역을 넘는 텍스트 숨기기 */
  text-overflow: ellipsis; /* 텍스트가 영역을 넘을 경우 말줄임표(...)로 표시 */
  width: 100%; /* 항목이 전체 너비를 사용하도록 설정 */
  max-width: 150px; /* 최대 너비 설정 (필요에 따라 조정) */
`;

export const CenterTitle = styled.div`
  position: absolute;
  top: -14.5px; /* 상단에서 위치를 조정 (필요에 따라 조정) */
  left: 50%;
  transform: translate(-50%, 0); /* 중앙 정렬 */
  padding: 4px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  background-color: ${({ theme }) => theme.palette.gray600};
  color: ${({ theme }) => theme.palette.gray15};
  font-size: 14px;
  font-weight: 500;
  z-index: 10; /* 다른 요소들 위에 표시되도록 설정 */
  width: auto; /* 너비 자동 조정 */
  max-width: none; /* 최대 너비 없음 */
`;

export const ModalContainer = styled(Flex)`
  padding: 12px;
`;

export const ModalContent = styled.span`
  text-align: center;
  white-space: pre-wrap;
`;

export const ErrorMessage = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #e13a3a;
`;
